import { LitElement, css } from 'lit';
import { html as staticHtml, unsafeStatic } from 'lit/static-html.js';
import { startRouter } from '../router.js';

/** Renders whichever page element the current path resolves to. */
class AppRouter extends LitElement {
  static properties = { route: { type: Object } };

  static styles = css`
    :host {
      display: block;
    }
  `;

  connectedCallback() {
    super.connectedCallback();
    this._teardown = startRouter(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this._teardown?.();
  }

  render() {
    const tag = unsafeStatic(this.route?.component ?? 'page-not-found');
    // The route goes to the page, so a page on a parameterised path can read what it matched
    // without parsing the URL a second time and getting a different answer.
    return staticHtml`<${tag} .route=${this.route}></${tag}>`;
  }
}

customElements.define('app-router', AppRouter);
